/**
 * Saksnummeret (tech-decisions «Saker har løpenummer per leietaker fra 10001», DD-63
 * presisert 2026-09-26): et løpenummer per leietaker fra 10001. Innsenderen ser «Sak 10042»,
 * panelet viser «#10042» — samme tall, uten tusenskille, for det er et navn og ikke en mengde.
 */
export const FORSTE_SAKSNUMMER = 10001;

/** «#10042» — slik raden, saken og kvitteringene i panelet skriver nummeret. */
export function saksnr(nummer: number): string {
  return `#${nummer}`;
}

/**
 * Det saksbehandleren skrev i søket, tolket som et saksnummer: «10042», «#10042» og «Sak 10042»
 * (også med små bokstaver og mellomrom rundt) gir 10042. Tom streng gir `undefined` (intet
 * søk); alt annet — også den gamle kortformen «e73f» — gir `null` (ikke et saksnummer).
 */
export function tolkSaksnummer(tekst: string): number | null | undefined {
  const rens = tekst.trim().replace(/^sak\s+/i, '').replace(/^#\s*/, '').trim();
  if (!rens) return undefined;
  if (!/^\d+$/.test(rens)) return null;
  const nummer = Number(rens);
  return Number.isSafeInteger(nummer) && nummer >= FORSTE_SAKSNUMMER && nummer <= 2_147_483_647 ? nummer : null;
}
